import * as Input from "../../components/Form/Input";
import * as Select from "../../components/Form/Select";
import { Lock, Mail } from "lucide-react";
import { Button } from "../../components/Button";
import { useMemo, useState } from "react";
import { userTypes } from "../../utils/userTypes";
import { useStore } from "../../store";

export function CreateUser() {
  const user = useStore((store) => store.user);
  const [name, setName] = useState("");
  const [last_name, setLastName] = useState("");

  const userTypesFill = useMemo(() => {
    if (user.user_type === "ADMIN" || user.user_type === "MANAGER") {
      return userTypes.filter(
        (user) =>
          user.id !== "CLIENT" &&
          user.id !== "SUPERADMIN" &&
          user.id !== "SELLER" &&
          user.id !== "ADMIN"
      );
    }
    return userTypes;
  }, [user]);

  return (
    <>
      <div className="mt-6 flex flex-col">
        <div className="flex flex-col justify-between gap-4 lg:flex-row lg:items-center">
          <div className="flex flex-col gap-1">
            <h2 className="text-lg font-medium text-zinc-900 dark:text-white">
              Informações pessoais
            </h2>
            <span className="text-sm text-zinc-500 dark:text-zinc-400">
              Cadastre seus clientes e crie usuários para acesso automatimente
            </span>
          </div>

          <div className="flex items-center gap-2">
            <Button type="button" variant="outline">
              Cancelar
            </Button>
            <Button type="submit" form="users" variant="primary">
              Salvar
            </Button>
          </div>
        </div>
      </div>

      <form
        id="users"
        className="mt-6 flex w-full flex-col gap-5 divide-y divide-zinc-200 dark:divide-zinc-800"
      >
        <div className="grid gap-3 lg:grid-cols-form">
          <label
            htmlFor="firstName"
            className="text-sm font-medium text-zinc-700 dark:text-zinc-100"
          >
            Nome
          </label>
          <div className="grid gap-6 lg:grid-cols-2">
            <Input.Root>
              <Input.Control
                name="firstName"
                placeholder="Nome"
                id="firstName"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Input.Root>
            <Input.Root>
              <Input.Control
                name="lastName"
                placeholder="Sobrenome"
                type="text"
                value={last_name}
                onChange={(e) => setLastName(e.target.value)}
              />
            </Input.Root>
          </div>
        </div>
        <div className="grid gap-3 lg:grid-cols-form pt-5">
          <label
            htmlFor="email"
            className="text-sm font-medium text-zinc-700 dark:text-zinc-100"
          >
            E-mail
          </label>
          <div className="flex gap-3">
            <Input.Root>
              <Input.Prefix>
                <Mail className="h-5 w-5 text-zinc-500" />
              </Input.Prefix>
              <Input.Control
                id="email"
                type="email"
                name="email"
                placeholder="E-mail do usuário"
              />
            </Input.Root>
          </div>
        </div>

        <div className="grid gap-3 lg:grid-cols-form pt-5">
          <label
            htmlFor="password"
            className="text-sm font-medium text-zinc-700 dark:text-zinc-100"
          >
            Senha
          </label>
          <div className="flex gap-3">
            <Input.Root>
              <Input.Prefix>
                <Lock className="h-5 w-5 text-zinc-500" />
              </Input.Prefix>
              <Input.Control
                id="password"
                type="password"
                name="password"
                placeholder="Senha"
              />
            </Input.Root>
          </div>
        </div>

        <label className="grid gap-3 pt-5 lg:grid-cols-form">
          <span className="flex flex-col text-sm font-medium leading-relaxed text-zinc-700 dark:text-zinc-100">
            Tipo de usuário
          </span>
          <Select.Root name="state">
            <Select.Trigger>
              <Select.Value placeholder="Selecione o estado" />
            </Select.Trigger>

            <Select.Content>
              {userTypesFill.map((user_type) => (
                <Select.Item value={user_type.id}>
                  <Select.ItemText>{user_type.title}</Select.ItemText>
                </Select.Item>
              ))}
            </Select.Content>
          </Select.Root>
        </label>

        <div className="flex items-center justify-end gap-2 pt-5">
          <Button type="button" variant="outline">
            Cancelar
          </Button>
          <Button type="submit" form="users" variant="primary">
            Salvar
          </Button>
        </div>
      </form>
    </>
  );
}
